import React, { Children, ReactNode } from 'react'
import { ListRecordProvider } from '../../context/ListRecordProvider'
import { LoadingProvider } from '../../context/LoadingProvider'
import RouteProvider from '../../context/RouteProvider'

interface IProviderWrapper {
  children: JSX.Element
}

function index({ children }: IProviderWrapper) {
  return (
    <>
      <RouteProvider />
      <ListRecordProvider>
        <LoadingProvider>
          {children}
        </LoadingProvider>
      </ListRecordProvider>
    </>
  )
}

export default index
